import 'uni-pages';
import Vue from 'vue'
import Page from './demo/pages/register/register.vue'
createPage(Page)